import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "archivings"

export const ArchivingRepository = {
    post: GeneratorRequest.post(nomApi, true),
    gets: GeneratorRequest.gets(nomApi, true),
}
